"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vtex = void 0;
var Vtex = /** @class */ (function () {
    function Vtex(window, storage) {
        this.VTEX_GENERIC_EVENT = 'message';
        this.ADD_TO_CART_EVENT = 'addToCart';
        this.ORDER_CREATED_EVENT = '';
        this.window = window;
        this.storage = storage;
    }
    Vtex.prototype.getCart = function () {
        var storeLocalStorageCart = this.window.localStorage.getItem('orderform');
        var storeCart = storeLocalStorageCart ? JSON.parse(storeLocalStorageCart) : null;
        if (storeCart === null) {
            return {
                currency: 'BRL',
                id: '',
                items: [],
                subtotal: 0
            };
        }
        var items = storeCart.items;
        var recoveredCartItems = items.map(function (item) { return ({
            id: item.id,
            quantity: item.quantity,
            unitPrice: item.price
        }); });
        var recoveredCartSubtotal = recoveredCartItems.reduce(function (sum, item) {
            sum += item.quantity * item.unitPrice;
            return sum;
        }, 0);
        return {
            currency: 'BRL',
            id: '',
            items: recoveredCartItems,
            subtotal: recoveredCartSubtotal / 100
        };
    };
    Vtex.prototype.getOrder = function () {
        return {
            isCompleted: false
        };
    };
    // TODO: extract cart diffing and subtotal recalculation functionality to Cart class
    // the method below should probably be renamed to something like extractLineItemsFrom event
    // and only return the value of line 61 addedCartItems
    // the Cart class should do the new/prev cart reduction lines 68-78 and subtotal lines 80-83
    Vtex.prototype.extractCartFromEvent = function (e) {
        var messageEvent = e;
        var cart = messageEvent.data;
        var storedCart = this.storedCart;
        var addedCartItems = cart.items.map(function (item) { return ({
            id: item.skuId,
            unitPrice: item.price,
            quantity: item.quantity
        }); });
        var newCartItems = addedCartItems.filter(function (i) { return storedCart.items.findIndex(function (v) { return v.id === i.id; }) < 0; });
        var prevCartItems = storedCart.items.map(function (item) {
            var newItemIndex = addedCartItems.findIndex(function (v) { return v.id === item.id; });
            if (newItemIndex >= 0)
                item.quantity = addedCartItems[newItemIndex].quantity + item.quantity;
            return {
                id: item.id,
                unitPrice: item.unitPrice,
                quantity: item.quantity
            };
        });
        var nextCartItems = __spreadArray(__spreadArray([], newCartItems, true), prevCartItems, true);
        var cartSubTotal = nextCartItems.reduce(function (sum, item) {
            sum += item.quantity * item.unitPrice;
            return sum;
        }, 0);
        return {
            id: storedCart.id,
            items: nextCartItems,
            currency: cart.currency,
            subtotal: cartSubTotal / 100
        };
    };
    Vtex.prototype.extractOrderFromEvent = function (e) {
        var _a;
        var messageEvent = e;
        var order = messageEvent.data;
        var isValidPhoneNumber = order.visitorContactPhone && !((_a = order.visitorContactPhone) === null || _a === void 0 ? void 0 : _a.includes('*'));
        return {
            currency: order.transactionCurrency,
            customerID: order.transactionId,
            id: order.transactionId,
            isCompleted: true,
            subtotal: order.transactionTotal,
            coupon: order.coupon || undefined,
            phone: isValidPhoneNumber ? order.visitorContactPhone : undefined
        };
    };
    Vtex.prototype.registerEvents = function (checkAndDispatchCartEvent) {
        var _this = this;
        this.window.addEventListener(this.VTEX_GENERIC_EVENT, function (e) {
            var messageEvent = e;
            var data = messageEvent.data;
            var event = typeof data === 'object' ? data.event : null;
            if (event === _this.ADD_TO_CART_EVENT)
                return checkAndDispatchCartEvent(e);
        });
    };
    Object.defineProperty(Vtex.prototype, "storedCart", {
        get: function () {
            var cart = this.storage.get('cart');
            if (cart === null) {
                return {
                    currency: '',
                    id: '',
                    items: [],
                    subtotal: 0
                };
            }
            return cart;
        },
        enumerable: false,
        configurable: true
    });
    return Vtex;
}());
exports.Vtex = Vtex;
//# sourceMappingURL=data:application/json;base64,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